import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import ZoneDefinitionForm from 'Services/ProductManagement/Features/ZoneDefinition/Components/ZoneDefinitionForm'
import { SELECTED_ZONE_DEFINITION_PARAMETER_KEY } from 'Services/ProductManagement/Features/ZoneDefinition/Hooks/useZoneDefinitionsWithParams'
import { useGetSingleZoneDefinitionQuery } from 'Services/ProductManagement/Features/ZoneDefinition/zoneDefinitionApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function ZoneDefinitionEditPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/zone-definitions`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_ZONE_DEFINITION_PARAMETER_KEY}=${id}`
  )
  const { data: singleZoneDefinition, isLoading: isSingleLoading } =
    useGetSingleZoneDefinitionQuery(id ?? '', {
      skip: !id
    })

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Zone definitions`,
      link: baseUrl
    },
    {
      title: singleZoneDefinition ? singleZoneDefinition.id : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit zone definition`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isSingleLoading}>
        {singleZoneDefinition && (
          <ZoneDefinitionForm
            zoneDefinition={singleZoneDefinition}
            successBaseUrl={previousLocation}
          />
        )}
      </WithLoader>
    </Box>
  )
}
